/**
 * Global Imports
*/

import axios from 'axios';
import React from 'react';

/**
 * Local Imports
*/

import { TokenStorage } from './Token';
import { API_URL } from '../config/Api';

/**
 * Locals
*/

/**
 * 
 */
function BuildUri(uri, args) {
  Object.entries( args || {} ).forEach(([ name, value ]) => {
    uri = uri.replace(`{${ name }}`, value);
  });

  return uri;
}

/**
 * Exports
*/

/**
 * 
 */
export const ApiContext = React.createContext({
  fetch: null
});

/**
 * 
 */
export function ApiProvider(props) {
  /** Event Handlers **/

  /**
   * 
   */
  const handleFetch = (...requests) => {
    let loaded = 0;

    return new Promise((resolve, reject) => {
      for (const [ service, setter ] of requests) {
        service()
          .then( response => setter(response.data) )
          .catch(reject)
          .finally(() => {
            if (++loaded === requests.length) {
              resolve();
            }
          })
        ;
      }
    });
  };

  /** Output **/

  return (
    <ApiContext.Provider value={{ fetch: handleFetch }}>
      { props.children }
    </ApiContext.Provider>
  );
}

/**
 * 
 */
export function ApiRequest({ method, uri, uri_args, data, headers }) {
  const defaults = {
    Authorization: `${ TokenStorage.type() } ${ TokenStorage.get() }`
  };

  const config = {
    method: method,
    url: `${ API_URL }${ BuildUri(uri, uri_args) }`,
    headers: {
      ...defaults,
      ...( headers || {} ),
      common: {
        ...( (headers || {}).common || {} ),
        'X-Requested-With': 'XMLHttpRequest'
      }
    }
  };

  if (method.toLowerCase() === 'get') {
    config.params = data || {};
  } else {
    config.data = data || {};
  }

  return axios({
    ...config,
    headers: Object.fromEntries(
      Object.entries(config.headers).filter(entry => entry[1])
    )
  });
}